import React from 'react'

import { Space, Switch as AntSwitch } from 'antd'
import SwitchGroup from './SwitchGroup.jsx'

const Switch = ({ text, ...props }) => {
  return <Space>
    <AntSwitch {...props} />
    {text}
  </Space>
}

Switch.Group = SwitchGroup

export default Switch
